import React from 'react';
import { SectionWrapper } from './Shared';
import { Star, Quote, TrendingUp, Activity, BatteryCharging } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Marc S.',
    location: 'Austin, TX',
    age: 47,
    quote: "A los 47 años pensaba que mi 'dad bod' era permanente. Tras 4 semanas con Prime Architect, mi energía se duplicó. He bajado 12 libras de grasa abdominal y mis camisas vuelven a apretar en los brazos, no en la cintura. Mi esposa dice que parezco otro hombre.",
    result: '-12lbs de grasa en 30 días',
    icon: <TrendingUp className="w-5 h-5 text-prime-gold" data-id="element-167" />
  }, {
    name: 'David R.',
    location: 'Chicago, IL',
    age: 42,
    quote: "Lo mejor es la claridad mental. El 'brain fog' desapareció en la primera semana. Entreno 35 minutos y rindo más en mi empresa que cuando tenía 30. Este es el manual que todo hombre de mi edad debería recibir al cumplir los 40.",
    result: 'Optimizó T-Libre de 350 a 720 ng/dL',
    icon: <Activity className="w-5 h-5 text-prime-gold" data-id="element-168" />
  }, {
    name: 'Robert L.',
    location: 'Miami, FL',
    age: 51,
    quote: 'Era escéptico. Pensaba que necesitaba TRT. Este protocolo me enseñó a leer mi propia sangre y a usar la nutrición de Costco a mi favor. Mi libido regresó y mis dolores de rodilla desaparecieron. Increíble.',
    result: 'Recuperación total de energía',
    icon: <BatteryCharging className="w-5 h-5 text-prime-gold" data-id="element-169" />
  }];
  return <SectionWrapper data-id="element-170">
      <div className="text-center mb-16" data-id="element-171">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-172">
          Hombres Que Ya Recuperaron El Mando
        </h2>
        <div className="flex justify-center gap-1 mb-4" data-id="element-173">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-prime-gold fill-prime-gold" data-id="element-174" />)}
        </div>
        <p className="text-prime-textMuted" data-id="element-175">
          Resultados reales de hombres reales.
        </p>
      </div>

      {/* Featured Transformation Image */}
      <div className="mb-16 rounded-xl overflow-hidden border border-prime-gold/30 shadow-[0_0_40px_rgba(212,168,83,0.1)]" data-id="element-176">
        <img src="https://cdn.magicpatterns.com/uploads/nE5ZAKNFeHGNsuyhirZr5N/Concepto4.png" alt="Transformación: De Dad Bod a Arquitecto Prime — Marc perdió 12 lbs en 30 días" className="w-full h-auto object-cover" data-id="element-177" />
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-178">
        {testimonials.map((t, idx) => <div key={idx} className="bg-prime-card border border-white/5 rounded-xl p-8 relative flex flex-col" data-id="element-179">
            <Quote className="absolute top-6 right-6 w-12 h-12 text-white/5" data-id="element-180" />

            <div className="flex gap-1 mb-6" data-id="element-181">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-prime-gold fill-prime-gold" data-id="element-182" />)}
            </div>

            <p className="text-prime-text italic mb-8 flex-grow relative z-10" data-id="element-183">
              "{t.quote}"
            </p>

            <div className="mt-auto pt-6 border-t border-white/10" data-id="element-184">
              <div className="flex items-center gap-3 mb-4" data-id="element-185">
                <div className="w-12 h-12 rounded-full bg-prime-dark flex items-center justify-center border border-prime-gold/30 font-serif text-xl text-prime-gold" data-id="element-186">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-187">
                  <p className="text-white font-bold" data-id="element-188">
                    {t.name}{' '}
                    <span className="text-prime-textMuted font-normal text-sm" data-id="element-189">
                      ({t.age})
                    </span>
                  </p>
                  <p className="text-prime-textMuted text-sm" data-id="element-190">{t.location}</p>
                </div>
              </div>

              <div className="bg-prime-gold/10 border border-prime-gold/20 rounded p-3 flex items-center gap-3" data-id="element-191">
                {t.icon}
                <span className="text-prime-gold font-semibold text-sm" data-id="element-192">
                  {t.result}
                </span>
              </div>
            </div>
          </div>)}
      </div>
    </SectionWrapper>;
};